export default "__VITE_ASSET__4JVdS9Mu__"